(function ($) {
    $(document).ready(function () {
        $('.wc-block-grid__product-gallery img').on('click', function (e) {
            e.preventDefault();
            // Replace main image by the one clicked.
            $(this).parents('.wc-block-grid__product')
                .find('.wc-block-grid__product-image')
                .attr('src', $(this).attr('src'))
                .attr('srcset', $(this).attr('srcset'));
        });

        $('.product-gallery img').on('click', function (e) {
            e.preventDefault();
            // Replace main image by the one clicked.
            $(this).parents('.product')
                .find('.woocommerce-LoopProduct-link > img')
                .attr('src', $(this).attr('src'))
                .attr('srcset', $(this).attr('srcset'));
        });
    });
})(jQuery);
